/** @format — Strip payment_event markup leaked into TEXT_MESSAGE_CONTENT */

const PAYMENT_TAG_BLOCK =
  /<payment_event[\s\S]*?<\/payment_event>/gi;
const PAYMENT_SELF_CLOSE = /<payment_event[^>]*\/?>/gi;
const PAYMENT_CLOSE_FRAG = /<\/payment_event>/gi;
const PAYMENT_CLOSE_PARTIAL = /\s*\/?>\s*<\/paym\w*/gi;

/** Backend sometimes streams XML-ish attrs instead of STATE_DELTA */
const PAYMENT_ATTR_LEAK =
  /\s*(?:total_price_usd|posting_fee_usd|posting_fee_ngn|quote_id|vehicle_description|route_description|session_id|payment_phase|quotedAmount|quotedCurrency|payment_session_id|phase|payment_reference)="[^"]*"/gi;

/** Lines that are only leaked key="value" fragments */
const ATTR_ONLY_LINE = /^\s*[a-z_]+="[^"]*"\s*$/gim;

export function sanitizeStreamText(text) {
  if (!text || typeof text !== "string") return text ?? "";

  let out = text
    .replace(PAYMENT_TAG_BLOCK, "")
    .replace(PAYMENT_SELF_CLOSE, "")
    .replace(PAYMENT_CLOSE_FRAG, "")
    .replace(PAYMENT_CLOSE_PARTIAL, "")
    .replace(PAYMENT_ATTR_LEAK, "")
    .replace(ATTR_ONLY_LINE, "");

  out = out
    .replace(/Great\.\s*(?=[a-z_]+=")/gi, "Great. ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return out;
}

/** True when a delta looks like backend payment metadata, not user-facing prose */
export function isPaymentMetadataDelta(delta) {
  if (!delta || typeof delta !== "string") return false;
  return (
    /(?:total_price_usd|posting_fee_usd|posting_fee_ngn|quote_id|vehicle_description)=/i.test(
      delta,
    ) || /<\/payment_event/i.test(delta)
  );
}
